const forms = {
  onRequest: "Atas Permintaan", // translated 
  person: "orang", // translated 
  travelDate: "Tarikh Perjalanan", // translated 
  travelDates: "Tarikh Perjalanan", // translated 
  cancel: "Batal", // translated 
  getPrice: "Dapatkan Harga", // translated 
};





export default forms;
